import React from 'react';

interface SuccessModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  onClose: () => void;
  buttonText?: string;
}

const SuccessModal: React.FC<SuccessModalProps> = ({
  isOpen,
  title,
  message,
  onClose,
  buttonText = "Continue"
}) => {
  if (!isOpen) return null;

  return (
    <>
      {/* Modal Backdrop */}
      <div 
        className="modal fade show d-block" 
        style={{ backgroundColor: 'rgba(40, 167, 69, 0.2)' }}
        tabIndex={-1}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content border-0 shadow" style={{ borderRadius: '20px', border: '3px solid #28a745' }}>
            {/* Modal Header */}
            <div className="modal-header bg-transparent border-0 p-4 pb-0">
              <div className="w-100 text-center position-relative">
                {/* Close Button */}
                <button
                  type="button"
                  className="btn-close position-absolute"
                  style={{ top: '-10px', right: '-10px' }}
                  onClick={onClose}
                  aria-label="Close"
                ></button>
                
                <div className="mb-3">
                  <div 
                    className="rounded-circle d-inline-flex align-items-center justify-content-center"
                    style={{ 
                      width: '64px', 
                      height: '64px', 
                      backgroundColor: '#28a745',
                      color: '#ffffff'
                    }}
                  >
                    <i className="fas fa-check fs-3"></i>
                  </div>
                </div>
                <h5 className="modal-title fw-bold text-success">
                  {title}
                </h5>
              </div>
            </div>

            {/* Modal Body */}
            <div className="modal-body p-4 pt-2">
              <div className="text-center mb-4">
                <p className="text-dark mb-3">
                  {message}
                </p>
              </div>

              {/* Action Button */}
              <div className="d-grid">
                <button
                  type="button"
                  className="btn btn-success btn-lg"
                  style={{ borderRadius: '12px' }}
                  onClick={onClose}
                >
                  <i className="fas fa-arrow-right me-2"></i>
                  {buttonText}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SuccessModal;